import {Action} from '@ngrx/store';

export class GetCurrentAccountAction implements Action {
  public static readonly type = 'GetCurrentAccountAction';

  public type = GetCurrentAccountAction.type;
}
